<template>
  <div class="container-fluid">
  <div class="card animated fadeIn">    
    <div class="card-header">
      <strong>Ficha Personal</strong>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
              <div class="form-group col-sm-3">
                <label for="dni">Dni</label>
                <input v-model="rowData.dni" type="text" name="dni" class="form-control" readonly>
              </div>
              <div class="form-group col-sm-4">
                    <label for="apellido">Apellido</label>
                    <input v-model="rowData.apellido" type="text" name="apellido" class="form-control" readonly>                  
              </div>
              <div class="form-group col-sm-5">
                    <label for="nombre">Nombre</label>
                    <input v-model="rowData.nombre" type="text" name="nombre" class="form-control" readonly>                  
              </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-6">
                      <label for="telefono">Telefono</label>                
                      <input v-model="rowData.telefono" type="text" name="telefono" class="form-control" readonly>                    
                </div>
                <div class="form-group col-sm-6">
                    <label for="fec_nac">Fecha de Nacimiento</label>
                    <input v-model="rowData.fec_nac" type="date" name="fec_nac" class="form-control" readonly>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-6">
                    <label>Nacionalidad</label>
                    <input v-model="rowData.nacionalidad" type="text"  class="form-control" readonly>
                </div>
                <div class="form-group col-sm-6">
                    <label>Localidad</label>
                    <input v-model="rowData.localidad" type="text"  class="form-control" readonly>
                </div>
            </div>            
            
            <div class="form-group row">
                  <label class="col-md-3 col-form-label" for="text-input">Direccion</label>
                  <div class="col-md-9">
                    <textarea v-model="rowData.direccion" name="dir_particular" id="direccion" cols="30" rows="3" class="form-control" readonly></textarea>                  
                  </div>
            </div>
        </div>
      </div>
    </div>    
  </div>
  </div>  
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
      console.log('my-detail-row: on-click', event.target)
    }
  },
}
</script>